// This is a skeleton starter React component generated by Plasmic.
// This file is owned by you, feel free to edit as you see fit.
import * as React from "react";
import { PlasmicSaveModal } from "./plasmic/cps/PlasmicSaveModal";

import { compose, lifecycle, withHandlers, withState } from 'recompose';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';
import { showSaveModal } from "../redux/reducers/view";
import { addComponentStatusRequest, saveStatus } from "../redux/reducers/addComponentStatus";
import { STATUSES } from "../constants";
import { xapiRequest } from "../redux/reducers/xapi";

function SaveModal_(props, ref) {
  
  return  <div>
{props.view.showSaveModal && <div style={{height:'100%', width:'100%', position:'absolute', top:0, left:0, zIndex:100000}}>
  <PlasmicSaveModal root={{ ref }} {...props} 
   btnNotStarted={{
    onClick:(e)=>{
      props.saveStatus(STATUSES.notStarted.value);
      props.addComponentStatusRequest();
      props.showSaveModal(false)

    }
  }}
  btnInProgress={{
    onClick:(e)=>{
      props.saveStatus(STATUSES.inProgress.value);
      props.addComponentStatusRequest();
      props.showSaveModal(false)
    }
  }}
  btnComplete={{
    onClick:(e)=>{
      props.saveStatus(STATUSES.completed.value);
      props.addComponentStatusRequest();
      props.showSaveModal(false);
      props.xapiRequest({xapiType:'Completed'})
    }
  }}
  btnClose={{
    onClick:(e)=>{
      props.showSaveModal(false)
    }
  }}

/>
</div>}
  </div>
}


const mapStateToProps = state => ({
  view: state.viewReducer
});
const mapDispatchToProps = dispatch => ({
  showSaveModal: bool => dispatch(showSaveModal(bool)),
  addComponentStatusRequest: () => dispatch(addComponentStatusRequest()),
  saveStatus: status => dispatch(saveStatus(status)),
  xapiRequest: obj => dispatch(xapiRequest(obj)),
  
});

const SaveModal = React.forwardRef(SaveModal_);

export default compose(
  connect(
    mapStateToProps,
    mapDispatchToProps,
  ),
  withRouter
)(SaveModal);



